
import { Swiper, Navigation } from "swiper";
import axios from "axios";
export default {
    name: 'product-info',
    data() {
        return {
            swiper: '',
            product_data: [],
            rank_status: 1
        }
    },
    methods: {
        async getProductData() {
            const API_url = "https://styleme.pixnet.net/api/recommend/products";
            const params = { limit: 10 }
            const data = await axios
                                .get(API_url ,{ params: params, responseType: "json" })
                                .catch((e)=> {
                                    console.log(e)
                                });
            this.product_data = data.data.products;
            // console.log(this.product_data)
        },
        async getNewProductData() {
            const API_url = "https://styleme.pixnet.net/api/newitems";
            const params = { limit: 10 }
            const data = await axios
                                .get(API_url ,{ params: params, responseType: "json" })
                                .catch((e)=> {
                                    console.log(e)
                                });
            this.product_data = data.data.new_items;
        },
        switchRankStatus(num) {
            if(this.rank_status != num) {
                if(num === 1) {
                    this.getProductData();
                } else if( num === 2) {
                    this.getNewProductData();
                }
                this.rank_status = num;
            }
        }
    },
    mounted() {
        this.getProductData();
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".product-info-swiper", {
            direction: "horizontal",
            observer: true,
            breakpoints: {
                769: {
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                }
            },
            slidesPerView: 2.3,
            spaceBetween: 12,
            modules: [Navigation]
        });
    }
}
